export const commentsContent = {
  intro:
    "Comments woh notes hotay hain jo code ko samajhne ke liye likhtay hain. Python in lines ko run nahi karta.",
  syntax: "# yeh comment hai",
  reasons: [
    {
      title: "Logic samjhana",
      description: "Comment batata hai ke next line ka kaam kya hai.",
    },
    {
      title: "Debugging mein help",
      description: "Temporary note likh kar ya line explain kar ke bug trace karna asaan hota hai.",
    },
    {
      title: "Teamwork",
      description: "Dusra banda code dekhe to foran samajh jaye ke flow kya hai.",
    },
  ],
  examples: [
    {
      id: "logic",
      title: "Logic explain karna",
      code: "# student ka total marks store karo\nmarks = 450\nprint(marks)",
      note: "Comment sirf samjhata hai, run sirf niche wali lines hoti hain.",
    },
    {
      id: "debug",
      title: "Debugging note",
      code: "price = 1200\n# discount baad mein apply hogi\nprint(price)",
      note: "Aap comment mein apni yaad-dahani bhi likh saktay ho.",
    },
    {
      id: "team",
      title: "Team ke liye context",
      code: "# yahan user se naam lena hai\nname = input(\"Enter name: \")",
      note: "Comment se next developer ko intent samajh aata hai.",
    },
  ],
  mistakes: [
    "Comment ko executable code samajhna.",
    "Comment ko aisi jagah likhna jahan woh line ki clarity aur kharab kar de.",
    "Purani ya ghalat comment rehne dena jo ab code se match nahi karti.",
  ],
  quiz: [
    {
      id: "comment-q1",
      question: "Python mein comment kis symbol se start hota hai?",
      options: ["//", "#", "--", "/*"],
      correctIndex: 1,
      explanation: "# Python ka single-line comment symbol hai.",
    },
    {
      id: "comment-q2",
      question: "Comment wali line ka kya hota hai?",
      options: ["Run hoti hai", "Ignore hoti hai", "Error deti hai", "Output print karti hai"],
      correctIndex: 1,
      explanation: "Python comment ko ignore karta hai, is liye woh execute nahi hoti.",
    },
    {
      id: "comment-q3",
      question: "Kaunsi line comment hai?",
      options: ["print(name)", "# print(name)", "name = \"Ali\"", "age = 20"],
      correctIndex: 1,
      explanation: "# se start hone wali line comment hai.",
    },
  ],
  faqs: [
    {
      question: "Python comments kya hotay hain?",
      answer: "Comments explanatory notes hotay hain jo code ko samajhne ke liye likhay jaty hain aur Python inhen run nahi karta.",
    },
    {
      question: "Comment aur code mein farq kya hai?",
      answer: "Code execute hota hai, jab ke comment sirf insan ke liye explanation hota hai.",
    },
  ],
};
